import React, { Component } from "react";
import {
  Button,
  Container,
  Row,
  Form,
  Col,
  Offcanvas,
  Modal,
  Alert,
  Card,
  Badge,
  ProgressBar,
  Accordion,
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from "../config.json";

import LoadingOverlay from "./LoadingOverlay";
export default class Stagingmemberstable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      company: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      filteredData: null,
      // Bulk upload state
      showBulkUpload: false,
      selectedFile: null,
      uploadProgress: 0,
      isUploading: false,
      uploadResults: null,
      duplicateRecords: [],
      showDuplicateModal: false,
      duplicateDecisions: {}, // Store user decisions for each duplicate
      isProcessingDuplicates: false,
      validationSummary: null,
      showSummaryModal: false,
      // Employee contact update
      showContactModal: false,
      employeeContactData: { employee_id: "", mobile_no: "", email_id: "" },

      // Bulk contact update
      showBulkContactModal: false,
      bulkContactFile: null,
      isBulkContactUploading: false,
      bulkContactProgress: 0,
      bulkContactResults: null,
      showBulkContactResultsModal: false,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.stagingmemberstable_Id,
          sortable: true,
          cell: (row) => <span>{row.stagingmemberstable_Id}</span>,
        },
        {
          name: "Employee Id",
          selector: (row, i) => row.employeeid,
          sortable: true,
          cell: (row) => <span>{row.employeeid}</span>,
        },
        {
          name: "Company Id",
          selector: (row, i) => row.companyid,
          sortable: true,
          cell: (row) => <span>{row.companyid}</span>,
        },
        {
          name: "Member Full Name",
          selector: (row, i) => row.memberfullname,
          sortable: true,
          cell: (row) => <span>{row.memberfullname}</span>,
        },
        {
          name: "Relation",
          selector: (row, i) => row.relationwithemployee,
          sortable: true,
          cell: (row) => <span>{row.relationwithemployee}</span>,
        },
        {
          name: "DOB",
          selector: (row, i) => row.dob,
          sortable: true,
          cell: (row) => <span>{row.dob}</span>,
        },
        {
          name: "Gender",
          selector: (row, i) => row.gender,
          sortable: true,
          cell: (row) => <span>{row.gender}</span>,
        },
        {
          name: "Sum Insured",
          selector: (row, i) => row.suminsured,
          sortable: true,
          cell: (row) => <span>{row.suminsured}</span>,
        },
        {
          name: "Pincode",
          selector: (row, i) => row.pincodenumber,
          sortable: true,
          cell: (row) => <span>{row.pincodenumber}</span>,
        },
        {
          name: "Validation Status",
          selector: (row, i) => row.validationstatus,
          sortable: true,
          cell: (row) => (
            <Badge
              bg={
                row.validationstatus === 1
                  ? "success"
                  : row.validationstatus === 2
                    ? "danger"
                    : "secondary"
              }
            >
              {row.validationstatus === 1
                ? "Passed"
                : row.validationstatus === 2
                  ? "Failed"
                  : "Pending"}
            </Badge>
          ),
        },
        {
          name: "Validation Remarks",
          selector: (row, i) => row.validationremarks,
          sortable: true,
          cell: (row) => (
            <span title={row.validationremarks}>
              {row.validationremarks
                ? row.validationremarks.substring(0, 50) + "..."
                : ""}
            </span>
          ),
        },
        {
          name: "Upload Status",
          selector: (row, i) => row.uploadstatus,
          sortable: true,
          cell: (row) => (
            <Badge
              bg={
                row.uploadstatus === "transferred"
                  ? "success"
                  : row.uploadstatus === "pending"
                    ? "warning"
                    : "secondary"
              }
            >
              {row.uploadstatus || "Pending"}
            </Badge>
          ),
        },
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                variant="primary"
                onClick={this.handleOffcanvasShow}
                className="bi bi-pen"
                style={{ marginRight: "3px" }}
              ></Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              ></Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 10,
      employeeid: "",
      companyid: "",
      memberfullname: "",
      dob: "",
      gender: "",
      relationwithemployee: "",
      suminsured: "",
      pincodenumber: "",
      validationstatus: "",
      validationremarks: "",
      uploadstatus: "",
      mobileno: "",
      emailid: "",
    };
  }
  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({ show: true });
  };
  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({ show: false });
  };
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg); // 'warn' is used instead of 'warning'
        break;
      default:
        toast.info(msg);
    }
  };
  StagingmemberstableeditHandler = (e) => {
    e.preventDefault();
    // const updateFormData = {...editFormData};
    // updateFormData['Stagingmemberstable_Id'] = e.target.parentElement.getAttribute("id");
    // setEditFormData(updateFormData);
    // setEdit(true);
  };
  HealthmemberdatafetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Company/list", {
      // Enter your IP address here
      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success" && data.list.length > 0) {
          this.setState({ company: data.list });
        }
      });
  };
  StagingmemberstablefetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Stagingmemberstable/list", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      });
  };
  StagingmemberstablesubmitHandler = (e) => {
    e.preventDefault();
    //   setButtons(contacts);
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("employeeid", this.state.employeeid);
    formData.append("companyid", this.state.companyid);
    formData.append("memberfullname", this.state.memberfullname);
    formData.append("dob", this.state.dob);
    formData.append("gender", this.state.gender);
    formData.append("relationwithemployee", this.state.relationwithemployee);
    formData.append("suminsured", this.state.suminsured);
    formData.append("pincodenumber", this.state.pincodenumber);
    formData.append("validationstatus", this.state.validationstatus);
    formData.append("validationremarks", this.state.validationremarks);
    formData.append("uploadstatus", this.state.uploadstatus);
    formData.append("mobileno", this.state.mobileno);
    formData.append("emailid", this.state.emailid);

    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + "C_Stagingmemberstable/add", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.StagingmemberstablefetchHandler();
          this.handleOffcanvasClose();
          this.setState({
            employeeid: "",
            companyid: "",
            memberfullname: "",
            dob: "",
            gender: "",
            relationwithemployee: "",
            suminsured: "",
            pincodenumber: "",
            validationstatus: "",
            validationremarks: "",
            uploadstatus: "",
            mobileno: "",
            emailid: "",
          });
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };
  StagingmemberstableupdateHandler = (e) => {
    e.preventDefault();
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("employeeid", this.state.employeeid);
    formData.append("companyid", this.state.companyid);
    formData.append("memberfullname", this.state.memberfullname);
    formData.append("dob", this.state.dob);
    formData.append("gender", this.state.gender);
    formData.append("relationwithemployee", this.state.relationwithemployee);
    formData.append("suminsured", this.state.suminsured);
    formData.append("pincodenumber", this.state.pincodenumber);
    formData.append("validationstatus", this.state.validationstatus);
    formData.append("validationremarks", this.state.validationremarks);
    formData.append("uploadstatus", this.state.uploadstatus);
    formData.append("mobileno", this.state.mobileno);
    formData.append("emailid", this.state.emailid);

    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + "C_Stagingmemberstable/update", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.StagingmemberstablefetchHandler();
          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };

  componentDidMount() {
    this.StagingmemberstablefetchHandler();
    this.HealthmemberdatafetchHandler();
  }
  handleemployeeidChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ employeeid: fieldValue });
  };
  handlecompanyidChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ companyid: fieldValue });
  };
  handlememberfullnameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ memberfullname: fieldValue });
  };
  handledobChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ dob: fieldValue });
  };
  handlegenderChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ gender: fieldValue });
  };
  handlerelationwithemployeeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ relationwithemployee: fieldValue });
  };
  handlesuminsuredChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ suminsured: fieldValue });
  };
  handlepincodenumberChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ pincodenumber: fieldValue });
  };
  handlevalidationstatusChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ validationstatus: fieldValue });
  };
  handlevalidationremarksChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ validationremarks: fieldValue });
  };
  handleuploadstatusChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ uploadstatus: fieldValue });
  };
  handlemobilenoChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ mobileno: fieldValue });
  };
  handleemailidChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ emailid: fieldValue });
  };
  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };
  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
    // implement your edit logic here
  };
  handleDelete = (row, index) => {
    var formData = new FormData();
    formData.append("stagingmemberstable_Id", row.stagingmemberstable_Id);
    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + "C_Stagingmemberstable/delete", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.StagingmemberstablefetchHandler();
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };
  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  // Bulk Upload Handlers
  handleBulkUploadShow = () => {
    this.setState({ showBulkUpload: true });
  };

  handleBulkUploadClose = () => {
    this.setState({
      showBulkUpload: false,
      selectedFile: null,
      uploadProgress: 0,
      isUploading: false,
      uploadResults: null,
    });
  };

  handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validate file type
      const allowedTypes = ["text/csv", "application/csv"];
      if (
        !allowedTypes.includes(file.type) &&
        !file.name.toLowerCase().endsWith(".csv")
      ) {
        this.showToast("Please select a valid CSV file", "error");
        e.target.value = "";
        return;
      }

      // Validate file size (10MB max)
      if (file.size > 10 * 1024 * 1024) {
        this.showToast("File size should not exceed 10MB", "error");
        e.target.value = "";
        return;
      }

      this.setState({ selectedFile: file });
    }
  };

  handleBulkUpload = () => {
    if (!this.state.selectedFile) {
      this.showToast("Please select a file first", "error");
      return;
    }

    this.setState({ isUploading: true, uploadProgress: 0 });

    const formData = new FormData();
    formData.append("file", this.state.selectedFile);
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("companyid", this.state.companyid || "");

    // Simulate progress
    const progressInterval = setInterval(() => {
      this.setState((prevState) => ({
        uploadProgress: Math.min(prevState.uploadProgress + 10, 90),
      }));
    }, 200);

    fetch(configData.api_url + "C_Stagingmemberstable/bulk_upload", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        clearInterval(progressInterval);
        this.setState({ uploadProgress: 100, isUploading: false });

        this.showToast(data.message, data.status);

        if (data.status === "success") {
          // Set both upload results and validation summary from the immediate response
          this.setState({
            uploadResults: data,
            validationSummary: data.validation_summary || null,
            showSummaryModal: true,
          });

          if (data.duplicates && data.duplicates.length > 0) {
            this.setState({
              duplicateRecords: data.duplicates,
              showDuplicateModal: true,
            });
          }

          this.StagingmemberstablefetchHandler();
          this.handleBulkUploadClose();
        }
      })
      .catch((error) => {
        clearInterval(progressInterval);
        this.setState({ isUploading: false, uploadProgress: 0 });
        this.showToast("Upload failed: " + error.message, "error");
      });
  };

  // Validation Summary Methods
  getValidationSummary = () => {
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("companyid", this.state.companyid || "");

    fetch(configData.api_url + "C_Stagingmemberstable/get_validation_summary", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({
            validationSummary: data.summary,
            showSummaryModal: true,
          });
        }
      });
  };

  // CSV Download Methods
  downloadValidationCSV = (validationType) => {
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("validation_type", validationType);
    formData.append("companyid", this.state.companyid || "");

    fetch(
      configData.api_url + "C_Stagingmemberstable/download_validation_csv",
      {
        method: "POST",
        mode: "cors",
        body: formData,
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          // Create download link
          const link = document.createElement("a");
          link.href = data.download_url;
          link.download = data.filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          this.showToast("CSV downloaded successfully", "success");
        } else {
          this.showToast(data.message, "error");
        }
      });
  };

  // Download Sample CSV Template
  downloadSampleCSV = () => {
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(configData.api_url + "C_Stagingmemberstable/download_sample_csv", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          // Create download link
          const link = document.createElement("a");
          link.href = data.download_url;
          link.download = data.filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          this.showToast(
            "Sample CSV template downloaded successfully",
            "success"
          );

          // Optionally show instructions in console or modal
          console.log("CSV Upload Instructions:", data.instructions);
        } else {
          this.showToast(data.message, "error");
        }
      })
      .catch((error) => {
        this.showToast(
          "Error downloading sample CSV: " + error.message,
          "error"
        );
      });
  };

  // Transfer to Production
  transferToProduction = () => {
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("companyid", this.state.companyid || "");

    fetch(configData.api_url + "C_Stagingmemberstable/transfer_to_production", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.StagingmemberstablefetchHandler();
          this.getValidationSummary();
        }
      });
  };

  // Duplicate Resolution - Individual Action
  handleDuplicateAction = (duplicateRecord, action) => {
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("action", action);
    formData.append(
      "existing_id",
      duplicateRecord.existing_data.stagingmemberstable_Id
    );

    if (action === "update") {
      // Add new data fields
      Object.keys(duplicateRecord.new_data).forEach((key) => {
        if (key !== "row_number") {
          formData.append(`new_data[${key}]`, duplicateRecord.new_data[key]);
        }
      });
    }

    fetch(configData.api_url + "C_Stagingmemberstable/resolve_duplicate", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          // Remove processed duplicate from list
          const updatedDuplicates = this.state.duplicateRecords.filter(
            (record) => record !== duplicateRecord
          );
          this.setState({ duplicateRecords: updatedDuplicates });

          if (updatedDuplicates.length === 0) {
            this.setState({ showDuplicateModal: false });
          }

          this.StagingmemberstablefetchHandler();
        }
      });
  };

  // Handle duplicate decision change
  handleDuplicateDecisionChange = (duplicateKey, action) => {
    this.setState({
      duplicateDecisions: {
        ...this.state.duplicateDecisions,
        [duplicateKey]: action,
      },
    });
  };

  // Process all duplicate decisions at once
  processAllDuplicateDecisions = () => {
    const { duplicateRecords, duplicateDecisions } = this.state;

    // Build decisions array
    const decisions = duplicateRecords.map((record) => ({
      existing_id: record.existing_data.stagingmemberstable_Id,
      new_data: record.new_data,
      action: duplicateDecisions[record.duplicate_key] || "skip",
    }));

    this.setState({ isProcessingDuplicates: true });

    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("decisions", JSON.stringify(decisions));

    fetch(
      configData.api_url + "C_Stagingmemberstable/process_duplicate_decisions",
      {
        method: "POST",
        mode: "cors",
        body: formData,
      }
    )
      .then((response) => response.json())
      .then((data) => {
        this.setState({ isProcessingDuplicates: false });
        this.showToast(data.message, data.status);

        if (data.status === "success") {
          this.setState({
            duplicateRecords: [],
            duplicateDecisions: {},
            showDuplicateModal: false,
          });

          this.StagingmemberstablefetchHandler();
        }
      })
      .catch((error) => {
        this.setState({ isProcessingDuplicates: false });
        this.showToast(
          "Error processing duplicates: " + error.message,
          "error"
        );
      });
  };

  // Employee Contact Update
  handleContactModalShow = () => {
    this.setState({ showContactModal: true });
  };

  handleContactModalClose = () => {
    this.setState({
      showContactModal: false,
      employeeContactData: { employee_id: "", mobile_no: "", email_id: "" },
    });
  };

  // Bulk Contact Update Methods
  handleBulkContactModalShow = () => {
    this.setState({ showBulkContactModal: true });
  };

  handleBulkContactModalClose = () => {
    this.setState({
      showBulkContactModal: false,
      bulkContactFile: null,
      bulkContactProgress: 0,
      bulkContactResults: null,
    });
  };

  handleBulkContactFileSelect = (e) => {
    const file = e.target.files[0];
    if (file && file.type === "text/csv") {
      this.setState({ bulkContactFile: file });
    } else {
      this.showToast("Please select a valid CSV file", "error");
      e.target.value = "";
    }
  };

  validateBulkContactData = (csvData) => {
    const errors = [];
    const validData = [];

    csvData.forEach((row, index) => {
      const rowErrors = [];
      const rowNumber = index + 2; // +2 because index starts at 0 and first row is header

      // Validate Employee ID (required)
      if (!row.employee_id || row.employee_id.trim() === "") {
        rowErrors.push(`Employee ID is required`);
      }

      // Validate Mobile Number (optional but format check if provided)
      if (row.mobile_number && row.mobile_number.trim() !== "") {
        const mobileRegex = /^[6-9]\d{9}$/;
        if (!mobileRegex.test(row.mobile_number.trim())) {
          rowErrors.push(
            `Invalid mobile number format (should be 10 digits starting with 6-9)`
          );
        }
      }

      // Validate Email ID (optional but format check if provided)
      if (row.email_id && row.email_id.trim() !== "") {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(row.email_id.trim())) {
          rowErrors.push(`Invalid email format`);
        }
      }

      // Validate Alternate Mobile Number (optional but format check if provided)
      if (
        row.alternate_mobile_number &&
        row.alternate_mobile_number.trim() !== ""
      ) {
        const mobileRegex = /^[6-9]\d{9}$/;
        if (!mobileRegex.test(row.alternate_mobile_number.trim())) {
          rowErrors.push(`Invalid alternate mobile number format`);
        }
      }

      // At least one contact field should be provided
      if (
        (!row.mobile_number || row.mobile_number.trim() === "") &&
        (!row.email_id || row.email_id.trim() === "") &&
        (!row.alternate_mobile_number ||
          row.alternate_mobile_number.trim() === "")
      ) {
        rowErrors.push(
          `At least one contact field (mobile_number, email_id, or alternate_mobile_number) must be provided`
        );
      }

      if (rowErrors.length > 0) {
        errors.push({
          row: rowNumber,
          employee_id: row.employee_id,
          errors: rowErrors,
        });
      } else {
        validData.push({
          employee_id: row.employee_id.trim(),
          mobile_number: row.mobile_number ? row.mobile_number.trim() : "",
          email_id: row.email_id ? row.email_id.trim() : "",
          alternate_mobile_number: row.alternate_mobile_number
            ? row.alternate_mobile_number.trim()
            : "",
        });
      }
    });

    return { errors, validData };
  };

  processBulkContactUpload = () => {
    if (!this.state.bulkContactFile) {
      this.showToast("Please select a CSV file", "error");
      return;
    }

    this.setState({ isBulkContactUploading: true, bulkContactProgress: 10 });

    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const csv = e.target.result;
        const lines = csv.split("\n");

        if (lines.length < 2) {
          this.showToast(
            "CSV file must contain at least header and one data row",
            "error"
          );
          this.setState({ isBulkContactUploading: false });
          return;
        }

        // Parse CSV
        const headers = lines[0].split(",").map((h) => h.trim().toLowerCase());
        const expectedHeaders = [
          "employee_id",
          "mobile_number",
          "email_id",
          "alternate_mobile_number",
        ];

        // Check if all required headers are present
        const missingHeaders = expectedHeaders.filter(
          (h) => !headers.includes(h)
        );
        if (missingHeaders.length > 0) {
          this.showToast(
            `Missing required headers: ${missingHeaders.join(", ")}`,
            "error"
          );
          this.setState({ isBulkContactUploading: false });
          return;
        }

        this.setState({ bulkContactProgress: 30 });

        // Parse data rows
        const csvData = [];
        for (let i = 1; i < lines.length; i++) {
          if (lines[i].trim() === "") continue; // Skip empty lines

          const values = lines[i].split(",").map((v) => v.trim());
          const row = {};
          headers.forEach((header, index) => {
            row[header] = values[index] || "";
          });
          csvData.push(row);
        }

        this.setState({ bulkContactProgress: 50 });

        // Validate data
        const validation = this.validateBulkContactData(csvData);

        if (validation.errors.length > 0) {
          this.setState({
            isBulkContactUploading: false,
            bulkContactResults: {
              status: "validation_failed",
              errors: validation.errors,
              validCount: validation.validData.length,
              errorCount: validation.errors.length,
            },
            showBulkContactResultsModal: true,
          });
          return;
        }

        this.setState({ bulkContactProgress: 70 });

        // Send valid data to backend
        const formData = new FormData();
        formData.append("sId", this.state.sId);
        formData.append("uId", this.state.uId);
        formData.append("contactData", JSON.stringify(validation.validData));

        fetch(
          configData.api_url + "C_Stagingmemberstable/bulk_update_contacts",
          {
            method: "POST",
            mode: "cors",
            body: formData,
          }
        )
          .then((response) => response.json())
          .then((data) => {
            this.setState({
              isBulkContactUploading: false,
              bulkContactProgress: 100,
              bulkContactResults: data,
              showBulkContactResultsModal: true,
            });

            if (data.status === "success") {
              this.showToast(
                `Successfully updated ${data.updated_count || 0
                } employee contacts`,
                "success"
              );
              this.StagingmemberstablefetchHandler(); // Refresh the table
            } else {
              this.showToast(
                data.message || "Error updating contacts",
                "error"
              );
            }
          })
          .catch((error) => {
            this.setState({
              isBulkContactUploading: false,
              bulkContactResults: {
                status: "error",
                message: "Error uploading contacts: " + error.message,
              },
              showBulkContactResultsModal: true,
            });
            this.showToast(
              "Error uploading contacts: " + error.message,
              "error"
            );
          });
      } catch (error) {
        this.setState({ isBulkContactUploading: false });
        this.showToast("Error parsing CSV file: " + error.message, "error");
      }
    };

    reader.readAsText(this.state.bulkContactFile);
  };

  downloadBulkContactTemplate = () => {
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(
      configData.api_url + "C_Stagingmemberstable/download_contact_template",
      {
        method: "POST",
        mode: "cors",
        body: formData,
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          // Create download link
          const link = document.createElement("a");
          link.href = data.download_url;
          link.download = data.filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          this.showToast(
            `Contact template downloaded successfully with ${data.employee_count || 0
            } employees pre-filled`,
            "success"
          );

          // Optionally show instructions in console
          console.log("Contact CSV Upload Instructions:", data.instructions);
        } else {
          this.showToast(data.message, "error");
        }
      })
      .catch((error) => {
        this.showToast(
          "Error downloading contact template: " + error.message,
          "error"
        );
      });
  };

  handleContactDataChange = (field, value) => {
    this.setState({
      employeeContactData: {
        ...this.state.employeeContactData,
        [field]: value,
      },
    });
  };

  updateEmployeeContact = () => {
    const { employeeContactData } = this.state;

    if (!employeeContactData.employee_id) {
      this.showToast("Employee ID is required", "error");
      return;
    }

    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("employee_id", employeeContactData.employee_id);
    formData.append("mobile_no", employeeContactData.mobile_no);
    formData.append("email_id", employeeContactData.email_id);

    fetch(
      configData.api_url + "C_Stagingmemberstable/update_employee_contact",
      {
        method: "POST",
        mode: "cors",
        body: formData,
      }
    )
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.handleContactModalClose();
          this.StagingmemberstablefetchHandler();
        }
      });
  };

  render() {
    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.data.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      );

    return (
      <div>
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="page-title">
          <div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">
              <div className="x_panel">
                <div className="x_content">
                  <div
                    id="datatable_wrapper"
                    className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
                  >
                    <Row className="row">
                      <div>
                        <h3
                          className="logoskybluecolor"
                          style={{ textAlign: "start" }}
                        >
                          Staging Members Table
                        </h3>
                      </div>
                      <Col
                        className="d-flex justify-content-end"
                        style={{ marginRight: "5px", marginTop: "20px" }}
                      >
                        <Offcanvas
                          show={this.state.show}
                          onHide={this.handleOffcanvasClose}
                          {...this.props}
                          style={{ width: "500px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>
                              Stagingmemberstable page
                            </Offcanvas.Title>
                          </Offcanvas.Header>
                          <Offcanvas.Body>
                            <Container
                              style={{ overflowY: "auto", height: "auto" }}
                            >
                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Employee Id
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="number"
                                          onChange={this.handleemployeeidChange}
                                          className="form-control"
                                          name="employeeid"
                                          value={this.state.employeeid}
                                          required="required"
                                          placeholder="Enter employeeid"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.employeeid}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Company Id
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="number"
                                          onChange={this.handlecompanyidChange}
                                          className="form-control"
                                          name="companyid"
                                          value={this.state.companyid}
                                          required="required"
                                          placeholder="Enter companyid"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.companyid}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Member Full Name
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handlememberfullnameChange
                                          }
                                          className="form-control"
                                          name="memberfullname"
                                          value={this.state.memberfullname}
                                          required="required"
                                          placeholder="Enter memberfullname"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.memberfullname}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Dob
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="date"
                                          onChange={this.handledobChange}
                                          className="form-control"
                                          name="dob"
                                          value={this.state.dob}
                                          required="required"
                                          placeholder="Enter dob"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.dob}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Gender
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handlegenderChange}
                                          className="form-control"
                                          name="gender"
                                          value={this.state.gender}
                                          required="required"
                                          placeholder="Enter gender"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.gender}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Relation With Employee
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this
                                              .handlerelationwithemployeeChange
                                          }
                                          className="form-control"
                                          name="relationwithemployee"
                                          value={
                                            this.state.relationwithemployee
                                          }
                                          required="required"
                                          placeholder="Enter relationwithemployee"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {
                                          this.state.errors.relationwithemployee
                                        }{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Suminsured
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handlesuminsuredChange}
                                          className="form-control"
                                          name="suminsured"
                                          value={this.state.suminsured}
                                          required="required"
                                          placeholder="Enter suminsured"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.suminsured}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Pincode Number
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handlepincodenumberChange
                                          }
                                          className="form-control"
                                          name="pincodenumber"
                                          value={this.state.pincodenumber}
                                          required="required"
                                          placeholder="Enter pincodenumber"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.pincodenumber}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Validation Status
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handlevalidationstatusChange
                                          }
                                          className="form-control"
                                          name="validationstatus"
                                          value={this.state.validationstatus}
                                          required="required"
                                          placeholder="Enter validationstatus"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {
                                          this.state.errors.validationstatus
                                        }{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Validation Remarks
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handlevalidationremarksChange
                                          }
                                          className="form-control"
                                          name="validationremarks"
                                          value={this.state.validationremarks}
                                          required="required"
                                          placeholder="Enter validationremarks"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {
                                          this.state.errors.validationremarks
                                        }{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Upload Status
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handleuploadstatusChange
                                          }
                                          className="form-control"
                                          name="uploadstatus"
                                          value={this.state.uploadstatus}
                                          required="required"
                                          placeholder="Enter uploadstatus"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.uploadstatus}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Mobile No
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="number"
                                          onChange={this.handlemobilenoChange}
                                          className="form-control"
                                          name="mobileno"
                                          value={this.state.mobileno}
                                          required="required"
                                          placeholder="Enter mobileno"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.mobileno}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Emailid
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handleemailidChange}
                                          className="form-control"
                                          name="emailid"
                                          value={this.state.emailid}
                                          required="required"
                                          placeholder="Enter emailid"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.emailid}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                  </Form>
                                </Row>
                              </Row>
                              <Row>
                                <Col
                                  className="d-flex justify-content-end"
                                  style={{ marginRight: "50px" }}
                                >
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={
                                      this.StagingmemberstablesubmitHandler
                                    }
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    Save
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                        {/*offcanvas is over */}
                      </Col>
                    </Row>
                    <br />
                    <Row>
                      <div style={{ marginRight: "5px" }}>
                        {/* searchbar,pagination,filter */}
                        <input
                          type="text"
                          style={{ float: "left", marginBottom: "10px" }}
                          onChange={this.handleFilter}
                          placeholder="Search..."
                        />
                        <div style={{ float: "right", marginBottom: "10px" }}>
                          <Button
                            variant="info"
                            className="me-2"
                            onClick={this.getValidationSummary}
                            style={{ marginRight: "5px" }}
                          >
                            <i className="bi bi-bar-chart"></i> Summary
                          </Button>
                          <Button
                            variant="warning"
                            className="me-2"
                            onClick={this.handleContactModalShow}
                            style={{ marginRight: "5px" }}
                          >
                            <i className="bi bi-person-gear"></i> Update Contact
                          </Button>
                          <Button
                            variant="secondary"
                            className="me-2"
                            onClick={this.handleBulkContactModalShow}
                            style={{ marginRight: "5px" }}
                          >
                            <i className="bi bi-cloud-upload-fill"></i> Bulk
                            Contact Update
                          </Button>
                          <Button
                            variant="success"
                            className="me-2"
                            onClick={this.handleBulkUploadShow}
                            style={{ marginTop: "0px" }}
                          >
                            <i className="bi bi-cloud-upload"></i> Bulk Upload
                          </Button>
                          <Button
                            variant="primary"
                            className="bi bi-plus"
                            onClick={this.handleOffcanvasShow}
                          >
                            New
                          </Button>
                        </div>
                        <DataTable
                          data={paginatedData}
                          columns={this.state.tableClms}
                          pagination
                          paginationServer
                          paginationTotalRows={
                            this.state.filteredData
                              ? this.state.filteredData.length
                              : this.state.data.length
                          }
                          onChangeRowsPerPage={this.handlePerRowsChange}
                          onChangePage={this.handlePageChange}
                          paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                          paginationPerPage={100}
                          keyField="id"
                          className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                        />
                      </div>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bulk Upload Modal */}
        <Modal
          show={this.state.showBulkUpload}
          onHide={this.handleBulkUploadClose}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Bulk Upload Members</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Alert variant="info">
              <h6>File Format Requirements:</h6>
              <ul>
                <li>
                  <strong>Supported formats: CSV only</strong> (Excel support
                  temporarily disabled)
                </li>
                <li>
                  Required columns: employeeid, memberfullname,
                  relationwithemployee, dob, gender, suminsured, pincode
                </li>
                <li>Date format: dd-mm-yyyy</li>
                <li>Gender: male or female</li>
                <li>
                  Relation: Self, Spouse, Mother, Father, Son, Daughter,
                  Motherinlaw, Fatherinlaw
                </li>
                <li>Pincode: 6 digits</li>
                <li>Max file size: 10MB</li>
              </ul>
            </Alert>

            <Alert variant="warning">
              <h6>Important Validation Rules:</h6>
              <ul>
                <li>
                  <strong>Employee First:</strong> You must include the employee
                  (Self relation) before adding dependents
                </li>
                <li>
                  <strong>Duplicate Prevention:</strong> System checks for
                  duplicates based on Company ID + Employee ID + Member Full
                  Name
                </li>
                <li>
                  <strong>Immediate Feedback:</strong> Validation results will
                  be shown immediately after upload
                </li>
              </ul>
            </Alert>

            <div className="mb-3 text-center">
              <Button
                variant="outline-primary"
                onClick={this.downloadSampleCSV}
                className="me-2"
              >
                <i className="bi bi-download me-1"></i>
                Download Sample CSV Template
              </Button>
              <small className="text-muted d-block mt-1">
                Download a pre-formatted CSV template with column headers and
                sample data
              </small>
            </div>
            <Row>
              <Col>
                <select
                  className="form-select"
                  name="companyid"
                  value={this.state.companyid}
                  onChange={this.handlecompanyidChange}
                >
                  <option defaultValue> Select Company</option>
                  {this.state.company.map((api, index, idx) => (
                    <option key={index} value={api.companyId}>
                      {" "}
                      {api.companyName}{" "}
                    </option>
                  ))}
                </select>
              </Col>
            </Row>
            <Form.Group className="mb-3">
              <Form.Label>Select File</Form.Label>
              <Form.Control
                type="file"
                accept=".csv"
                onChange={this.handleFileSelect}
              />
            </Form.Group>

            {this.state.selectedFile && (
              <Alert variant="success">
                Selected file: {this.state.selectedFile.name}
              </Alert>
            )}

            {this.state.isUploading && (
              <div>
                <ProgressBar
                  now={this.state.uploadProgress}
                  label={`${this.state.uploadProgress}%`}
                  className="mb-3"
                />
                <p>Processing file...</p>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleBulkUploadClose}>
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={this.handleBulkUpload}
              disabled={!this.state.selectedFile || this.state.isUploading}
            >
              {this.state.isUploading ? "Uploading..." : "Upload"}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Validation Summary Modal */}
        <Modal
          show={this.state.showSummaryModal}
          onHide={() => this.setState({ showSummaryModal: false })}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Validation Summary</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.validationSummary && (
              <Row>
                <Col md={6}>
                  <Card className="mb-3">
                    <Card.Body>
                      <Card.Title className="text-primary">
                        Total Records
                      </Card.Title>
                      <h3>{this.state.validationSummary.total_records}</h3>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={6}>
                  <Card className="mb-3">
                    <Card.Body>
                      <Card.Title className="text-success">
                        Validation Passed
                      </Card.Title>
                      <h3>{this.state.validationSummary.validation_passed}</h3>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={6}>
                  <Card className="mb-3">
                    <Card.Body>
                      <Card.Title className="text-danger">
                        Validation Failed
                      </Card.Title>
                      <h3>{this.state.validationSummary.validation_failed}</h3>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={6}>
                  <Card className="mb-3">
                    <Card.Body>
                      <Card.Title className="text-warning">
                        Pending Transfer
                      </Card.Title>
                      <h3>{this.state.validationSummary.pending_transfer}</h3>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            )}

            {this.state.uploadResults && (
              <Alert variant="info">
                <h6>Latest Upload Results:</h6>
                <Row>
                  <Col md={6}>
                    <Card className="mb-2">
                      <Card.Body className="text-center">
                        <Card.Title className="text-primary">
                          Total Processed
                        </Card.Title>
                        <h4>
                          {this.state.uploadResults.upload_summary
                            ? this.state.uploadResults.upload_summary
                              .total_processed
                            : this.state.uploadResults.summary
                              ?.total_processed || 0}
                        </h4>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col md={6}>
                    <Card className="mb-2">
                      <Card.Body className="text-center">
                        <Card.Title className="text-success">
                          Valid Records
                        </Card.Title>
                        <h4>
                          {this.state.uploadResults.upload_summary
                            ? this.state.uploadResults.upload_summary
                              .valid_records
                            : this.state.uploadResults.summary?.valid_records ||
                            0}
                        </h4>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col md={6}>
                    <Card className="mb-2">
                      <Card.Body className="text-center">
                        <Card.Title className="text-danger">
                          Invalid Records
                        </Card.Title>
                        <h4>
                          {this.state.uploadResults.upload_summary
                            ? this.state.uploadResults.upload_summary
                              .invalid_records
                            : this.state.uploadResults.summary
                              ?.invalid_records || 0}
                        </h4>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col md={6}>
                    <Card className="mb-2">
                      <Card.Body className="text-center">
                        <Card.Title className="text-warning">
                          Duplicate Records
                        </Card.Title>
                        <h4>
                          {this.state.uploadResults.upload_summary
                            ? this.state.uploadResults.upload_summary
                              .duplicate_records
                            : this.state.uploadResults.summary
                              ?.duplicate_records || 0}
                        </h4>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </Alert>
            )}
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex gap-2">
              <Button
                variant="success"
                onClick={() => this.downloadValidationCSV("passed")}
              >
                Download Passed CSV
              </Button>
              <Button
                variant="danger"
                onClick={() => this.downloadValidationCSV("failed")}
              >
                Download Failed CSV
              </Button>
              <Button variant="primary" onClick={this.transferToProduction}>
                Transfer to Production
              </Button>
              <Button
                variant="secondary"
                onClick={() => this.setState({ showSummaryModal: false })}
              >
                Close
              </Button>
            </div>
          </Modal.Footer>
        </Modal>

        {/* Duplicate Records Modal */}
        <Modal
          show={this.state.showDuplicateModal}
          onHide={() => this.setState({ showDuplicateModal: false })}
          size="xl"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Duplicate Records Found ({this.state.duplicateRecords.length})
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Alert variant="warning">
              <strong>Duplicate Records Detected:</strong> The following records
              already exist in the system. Please choose an action for each
              record. You can either update the existing record with new data or
              skip the upload.
            </Alert>

            <Alert variant="info">
              <strong>Batch Processing:</strong> Use the dropdown for each
              record to select an action, then click "Process All Decisions" to
              apply all changes at once.
            </Alert>

            <Accordion>
              {this.state.duplicateRecords.map((record, index) => (
                <Accordion.Item eventKey={index.toString()} key={index}>
                  <Accordion.Header>
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <span>
                        Row {record.new_data.row_number}:{" "}
                        {record.new_data.memberfullname} (Employee:{" "}
                        {record.new_data.employeeid})
                      </span>
                      <Badge
                        bg={
                          this.state.duplicateDecisions[
                            record.duplicate_key
                          ] === "update"
                            ? "success"
                            : this.state.duplicateDecisions[
                              record.duplicate_key
                            ] === "skip"
                              ? "secondary"
                              : "warning"
                        }
                      >
                        {this.state.duplicateDecisions[record.duplicate_key] ||
                          "Pending"}
                      </Badge>
                    </div>
                  </Accordion.Header>
                  <Accordion.Body>
                    <Row>
                      <Col md={6}>
                        <h6 className="text-primary">
                          New Record (From Upload):
                        </h6>
                        <p>
                          <strong>Name:</strong>{" "}
                          {record.new_data.memberfullname}
                        </p>
                        <p>
                          <strong>Employee ID:</strong>{" "}
                          {record.new_data.employeeid}
                        </p>
                        <p>
                          <strong>Relation:</strong>{" "}
                          {record.new_data.relationwithemployee}
                        </p>
                        <p>
                          <strong>DOB:</strong> {record.new_data.dob}
                        </p>
                        <p>
                          <strong>Gender:</strong> {record.new_data.gender}
                        </p>
                        <p>
                          <strong>Sum Insured:</strong>{" "}
                          {record.new_data.suminsured}
                        </p>
                        <p>
                          <strong>Pincode:</strong>{" "}
                          {record.new_data.pincodenumber}
                        </p>
                      </Col>
                      <Col md={6}>
                        <h6 className="text-warning">
                          Existing Record (In System):
                        </h6>
                        <p>
                          <strong>Name:</strong>{" "}
                          {record.existing_data.memberfullname}
                        </p>
                        <p>
                          <strong>Employee ID:</strong>{" "}
                          {record.existing_data.employeeid}
                        </p>
                        <p>
                          <strong>Relation:</strong>{" "}
                          {record.existing_data.relationwithemployee}
                        </p>
                        <p>
                          <strong>DOB:</strong> {record.existing_data.dob}
                        </p>
                        <p>
                          <strong>Gender:</strong> {record.existing_data.gender}
                        </p>
                        <p>
                          <strong>Sum Insured:</strong>{" "}
                          {record.existing_data.suminsured}
                        </p>
                        <p>
                          <strong>Pincode:</strong>{" "}
                          {record.existing_data.pincodenumber}
                        </p>
                      </Col>
                    </Row>

                    <div className="mt-3">
                      <h6>Choose Action:</h6>
                      <Form.Select
                        value={
                          this.state.duplicateDecisions[record.duplicate_key] ||
                          ""
                        }
                        onChange={(e) =>
                          this.handleDuplicateDecisionChange(
                            record.duplicate_key,
                            e.target.value
                          )
                        }
                      >
                        <option value="">Select action...</option>
                        <option value="update">
                          Update existing record with new data
                        </option>
                        <option value="skip">
                          Skip this record (keep existing)
                        </option>
                      </Form.Select>

                      <div className="mt-2">
                        <Button
                          variant="primary"
                          size="sm"
                          className="me-2"
                          onClick={() =>
                            this.handleDuplicateAction(record, "update")
                          }
                        >
                          Update Individual
                        </Button>
                        <Button
                          variant="secondary"
                          size="sm"
                          onClick={() =>
                            this.handleDuplicateAction(record, "skip")
                          }
                        >
                          Skip Individual
                        </Button>
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex w-100 justify-content-between">
              <div>
                <small className="text-muted">
                  {Object.keys(this.state.duplicateDecisions).length} of{" "}
                  {this.state.duplicateRecords.length} decisions made
                </small>
              </div>
              <div>
                <Button
                  variant="success"
                  onClick={this.processAllDuplicateDecisions}
                  disabled={
                    this.state.isProcessingDuplicates ||
                    Object.keys(this.state.duplicateDecisions).length === 0
                  }
                  className="me-2"
                >
                  {this.state.isProcessingDuplicates
                    ? "Processing..."
                    : "Process All Decisions"}
                </Button>
                <Button
                  variant="secondary"
                  onClick={() => this.setState({ showDuplicateModal: false })}
                >
                  Close
                </Button>
              </div>
            </div>
          </Modal.Footer>
        </Modal>

        {/* Employee Contact Update Modal */}
        <Modal
          show={this.state.showContactModal}
          onHide={this.handleContactModalClose}
        >
          <Modal.Header closeButton>
            <Modal.Title>Update Employee Contact</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Employee ID</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Employee ID"
                  value={this.state.employeeContactData.employee_id}
                  onChange={(e) =>
                    this.handleContactDataChange("employee_id", e.target.value)
                  }
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Mobile Number</Form.Label>
                <Form.Control
                  type="tel"
                  placeholder="Enter Mobile Number"
                  value={this.state.employeeContactData.mobile_no}
                  onChange={(e) =>
                    this.handleContactDataChange("mobile_no", e.target.value)
                  }
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Email ID</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter Email ID"
                  value={this.state.employeeContactData.email_id}
                  onChange={(e) =>
                    this.handleContactDataChange("email_id", e.target.value)
                  }
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleContactModalClose}>
              Cancel
            </Button>
            <Button variant="primary" onClick={this.updateEmployeeContact}>
              Update Contact
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Bulk Contact Update Modal */}
        <Modal
          show={this.state.showBulkContactModal}
          onHide={this.handleBulkContactModalClose}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Bulk Contact Update</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Alert variant="info">
              <h6>CSV File Requirements:</h6>
              <ul>
                <li>
                  <strong>Required columns:</strong> employee_id, mobile_number,
                  email_id, alternate_mobile_number
                </li>
                <li>
                  <strong>Mobile number format:</strong> 10 digits starting with
                  6-9 (e.g., 9876543210)
                </li>
                <li>
                  <strong>Email format:</strong> Valid email address (e.g.,
                  user@example.com)
                </li>
                <li>
                  <strong>Employee ID:</strong> Must match existing employee
                  records
                </li>
                <li>
                  <strong>At least one contact field required:</strong>{" "}
                  mobile_number, email_id, or alternate_mobile_number
                </li>
                <li>
                  <strong>Empty fields:</strong> Leave blank to skip updating
                  that field
                </li>
              </ul>
            </Alert>

            <div className="mb-3 text-center">
              <Button
                variant="outline-primary"
                onClick={this.downloadBulkContactTemplate}
                className="me-2"
              >
                <i className="bi bi-download me-1"></i>
                Download CSV Template
              </Button>
              <small className="text-muted d-block mt-1">
                Download a template with correct column headers and sample data
              </small>
            </div>

            <Form.Group className="mb-3">
              <Form.Label>Select CSV File</Form.Label>
              <Form.Control
                type="file"
                accept=".csv"
                onChange={this.handleBulkContactFileSelect}
              />
              <Form.Text className="text-muted">
                Only CSV files are supported. Max file size: 5MB
              </Form.Text>
            </Form.Group>

            {this.state.bulkContactFile && (
              <Alert variant="success">
                <i className="bi bi-check-circle me-2"></i>
                Selected file:{" "}
                <strong>{this.state.bulkContactFile.name}</strong>
              </Alert>
            )}

            {this.state.isBulkContactUploading && (
              <div>
                <ProgressBar
                  now={this.state.bulkContactProgress}
                  label={`${this.state.bulkContactProgress}%`}
                  className="mb-3"
                />
                <p className="text-center">
                  <i className="bi bi-cloud-upload me-2"></i>
                  Processing contact updates...
                </p>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={this.handleBulkContactModalClose}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={this.processBulkContactUpload}
              disabled={
                !this.state.bulkContactFile || this.state.isBulkContactUploading
              }
            >
              {this.state.isBulkContactUploading
                ? "Processing..."
                : "Upload & Update Contacts"}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Bulk Contact Results Modal */}
        <Modal
          show={this.state.showBulkContactResultsModal}
          onHide={() => this.setState({ showBulkContactResultsModal: false })}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Bulk Contact Update Results</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.bulkContactResults && (
              <div>
                {this.state.bulkContactResults.status === "success" && (
                  <Alert variant="success">
                    <h5>
                      <i className="bi bi-check-circle me-2"></i>Update
                      Successful!
                    </h5>
                    <p>
                      <strong>
                        Updated{" "}
                        {this.state.bulkContactResults.updated_count || 0}{" "}
                        employee contact records
                      </strong>
                    </p>
                    {this.state.bulkContactResults.skipped_count > 0 && (
                      <p>
                        Skipped {this.state.bulkContactResults.skipped_count}{" "}
                        records (employee not found or no changes needed)
                      </p>
                    )}
                  </Alert>
                )}

                {this.state.bulkContactResults.status ===
                  "validation_failed" && (
                    <div>
                      <Alert variant="danger">
                        <h5>
                          <i className="bi bi-exclamation-triangle me-2"></i>
                          Validation Failed
                        </h5>
                        <p>
                          Found {this.state.bulkContactResults.errorCount}{" "}
                          validation errors in your CSV file.
                        </p>
                        <p>
                          Valid records:{" "}
                          {this.state.bulkContactResults.validCount}
                        </p>
                      </Alert>

                      <h6>Validation Errors:</h6>
                      <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                        {this.state.bulkContactResults.errors.map(
                          (error, index) => (
                            <Alert key={index} variant="warning" className="mb-2">
                              <strong>
                                Row {error.row} - Employee ID: {error.employee_id}
                              </strong>
                              <ul className="mb-0 mt-1">
                                {error.errors.map((err, i) => (
                                  <li key={i}>{err}</li>
                                ))}
                              </ul>
                            </Alert>
                          )
                        )}
                      </div>
                    </div>
                  )}

                {this.state.bulkContactResults.status === "error" && (
                  <Alert variant="danger">
                    <h5>
                      <i className="bi bi-exclamation-circle me-2"></i>Error
                    </h5>
                    <p>{this.state.bulkContactResults.message}</p>
                  </Alert>
                )}

                {this.state.bulkContactResults.details && (
                  <div className="mt-3">
                    <h6>Update Details:</h6>
                    <Row>
                      <Col md={4}>
                        <Card className="text-center">
                          <Card.Body>
                            <h4 className="text-success">
                              {this.state.bulkContactResults.updated_count || 0}
                            </h4>
                            <p>Updated</p>
                          </Card.Body>
                        </Card>
                      </Col>
                      <Col md={4}>
                        <Card className="text-center">
                          <Card.Body>
                            <h4 className="text-warning">
                              {this.state.bulkContactResults.skipped_count || 0}
                            </h4>
                            <p>Skipped</p>
                          </Card.Body>
                        </Card>
                      </Col>
                      <Col md={4}>
                        <Card className="text-center">
                          <Card.Body>
                            <h4 className="text-danger">
                              {this.state.bulkContactResults.error_count || 0}
                            </h4>
                            <p>Errors</p>
                          </Card.Body>
                        </Card>
                      </Col>
                    </Row>
                  </div>
                )}
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() =>
                this.setState({ showBulkContactResultsModal: false })
              }
            >
              Close
            </Button>
            {this.state.bulkContactResults?.status === "success" && (
              <Button
                variant="primary"
                onClick={() => {
                  this.setState({ showBulkContactResultsModal: false });
                  this.StagingmemberstablefetchHandler();
                }}
              >
                Refresh Data
              </Button>
            )}
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
